import React, { useEffect } from 'react';

const TRViewerSymbolDetails = ({ symbol }) => {
  useEffect(() => {
    const loadWidget = (symbolPrefix) => {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-info.js';
      script.innerHTML = JSON.stringify({
        "symbol": `${symbolPrefix}:${symbol}`,
        "width": "100%",
        "locale": "en",
        "colorTheme": "dark",
        "isTransparent": true
      });

      const widgetContainer = document.querySelector('.trdView-container');
      if (widgetContainer) {
        widgetContainer.innerHTML = ''; // Clear previous content if any
        widgetContainer.appendChild(script);
      } else {
        console.error('Widget container not found.');
      }
    };

    // Function to handle widget load error
    const handleWidgetError = () => {
      const widgetContainer = document.querySelector('.trdView-container');
      if (widgetContainer && widgetContainer.innerHTML.includes('height: 100%;')) {
        console.error('Invalid Symbol detected.'); // Handle invalid symbol case
        loadWidget('BINANCE');
      }
    };

    // First try with 'CRYPTO' prefix
    loadWidget('CRYPTO');

    // Check for errors after a short delay
    setTimeout(handleWidgetError, 1000); // Adjust delay as needed

    return () => {
      const widgetContainer = document.querySelector('.trdView-container');
      if (widgetContainer) {
        widgetContainer.innerHTML = '';
      } else {
        console.error('Widget container not found.');
      }
    };
  }, [symbol]);

  return (
    <div className="tradingview-widget-container" style={{width:'745px', height:'228px'}}>
      <div className="trdView-container"></div>
      <div className="tradingview-widget-copyright">        
      </div>
    </div>
  );
};

export default TRViewerSymbolDetails;